import { FC, PropsWithChildren, ReactElement } from 'react'

import './Page.scss'

export interface PageProps extends PropsWithChildren {
    className?: string;
}

const Page: FC<PageProps> = ({
    className = '',
    children,
}): ReactElement => (
    <main className={`page ${className}`}>
        {children}
    </main>
)

export default Page
